import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";

import merge from 'lodash-es/merge';

import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {EventsService} from "app/lib/EventsService";
import * as qs from 'qs';
import {BaseComponent} from "app/views/base.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {HelperService} from "app/lib/helper.service";
import {getSiteStatusStyle} from "../../lib/lib";
import * as moment from "moment-timezone";
import {AlertComponent} from "../../views/modal/alert.component";
import { SitesService } from "../sites.service";
import { ITotal } from "../../models/responce_result.model";


const DOWNLOAD_TYPE = { phone: true, app: true, domain: true, all: true };

interface IPublishedSiteTotal extends ITotal {
	totalCount: number;
	count: number;
	totals: object;
}

@Component({
	selector: 'published_site',
	templateUrl: './published_site.component.html',
})
export class PublishedSiteComponent extends BaseComponent {
	sort: any = {'date_create': 'desc'};
	typeDate: string = 'dateCreate';
	loadingInProgress: boolean = false;
	baseUrl: string = this.router.url.split('?')[0];
	totalCount: number = 0;
	filterCount: number = 0;

	addFilterParams = {
		userType: 'user',
		dateFilters: ['dateCreated', 'datePaid', 'dateSiteCreated', 'dateTo'],
		dateType: 'datePaid',
		typeDate: 'dateCreate'
	};

	public moment = moment;

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public modalService: ModalService,
		public filter: FilterFormService,
		public http: HttpClient,
		public helper: HelperService,
		public siteService: SitesService,
	) {
		super(eventsService, siteService, activatedRoute, filter, translate);
	}


	async getData() {
		this.sort = merge({}, this.filter.filterParams['sort'], this.sort);
		this.typeDate = this.filter.filterParams['typeDate'];
		
		await this.getPagination();
		await this.getTotal();
	}


	async applyFilter() {
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		this.filter.filterParams['sort'] = this.sort;
		this.filter.filterParams['typeDate'] = this.typeDate;
		this.filter.filterParams['page'] = this.pagination.page;

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});

		await this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
	}
	
	
	async getTotal() {
		const me = this;
		
		me.totalLoader = true;
		
		const { totalCount, count } = await me.siteService.publishedSite.total<IPublishedSiteTotal>(
			this.filter.filterParams
		).toPromise();

		me.totalLoader = false;
		
		me.totalCount  = totalCount;
		me.filterCount = count;
	}
	
	
	async getPagination() {
		const me = this;
		
		if (this.dontLoad.pagination) {
			await this.getStats();
			return true;
		}
		
		if (this.filter.filterParams.period !== 'summary') {
			this.paginationLoader = true;
			
			const pagination = await this.siteService.publishedSite.pagination(
				this.filter.filterParams
			).toPromise();
			me.pagination.fill(pagination);
			
			if (pagination) {
				me.updateLinks(
					me.siteService.publishedSite.getRealFullRoute()
				)
			}
			
			this.paginationLoader = false;
		}
		
		await this.getStats();
	}
	
	
	async getStats() {
		const me = this;
		
		if (this.pagination.pageCount === 0) {
			return ;
		}
		
		me.loadingInProgress = true;
		const { stats } = await this.siteService.publishedSite.stats(
			this.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.loadingInProgress = false;
		
		me.stats = stats;

		this.dontLoad = {};
	}
	
	
	downloadButton(t: string) {
		let fp = {};
		let action = '';
		
		if (t === 'cc') {
			fp = {
				fieldList: [
					'dateCreate',
					'lastInvoiceDateTo',
					'username',
					'email',
					'domainUrl',
					'domains',
					'phonesFromUser',
					'phonesFromSites',
					'phonesFromExternalData'
				],
				reportGUID: this.filter.reportGUID,
			};
		} else {
			fp ={
				reportGUID: this.filter.reportGUID,
			};
		}
		
		
		if (t === 'cc' || t === 'data') {
			action = 'csv';
		} else if (t === 'apps') {
			action = 'user_app_csv';
		} else {
			action = 'domains_csv';
		}

		window.location.href = this.siteService.publishedSite.downloadFileRoute(
			this.filter.getCopyFilterParams(
				fp
			),
			action
		);
		
		this.modalService.open(AlertComponent, {
			title: 'INFO',
			message: this.translate.__A('common.download file')
		});
	}
	
	
	total(sites: any[]) {
		if (sites) {
			return sites.reduce(function (total, site) {
				return parseInt(total) + parseInt(site.count);
			}, 0);
		}
		
		return 0;
	}
	
	
	/**
	 * Скачать данные по сайтам в виде CSV
	 * @param type Тип выборки (уточнить у Артёма)
	 */
	download(type:string) {
		const me = this;
		
		if ( ! DOWNLOAD_TYPE[type]) {
			throw new Error(`download: type '${type}'is not correct`);
		}
		
		window.location.href = me.siteService.publishedSite.downloadFileRoute(
			me.filter.getCopyFilterParams({ type }),
			'download'
		);
		
		me.modalService.open(AlertComponent, {
			title   : 'INFO',
			message : this.translate.__A('common.download file')
		});
	}
	
	
	public getSiteStatusStyle = getSiteStatusStyle;
	
	
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;
		
		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
		
		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];
		
		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});
		
		this.dontLoad = {
			pagination: true
		};
	}
	
	
	getSortClasses(sortFiledName: string): string {
		if ( ! sortFiledName) {
			return ;
		}
		
		if (this.sort[sortFiledName] === 'asc') {
			return 'fa-sort-amount-up'
		}

		if (this.sort[sortFiledName] === 'desc') {
			return 'fa-sort-amount-down';
		}
		
		return 'fa-sort';
	}


	async toggleSort(sortFiledName: string) {
		if ( ! sortFiledName) {
			return ;
		}
		
		const sortDirection = this.sort[sortFiledName];
		
		this.sort = {};
		this.sort[sortFiledName] = sortDirection === 'asc' ? 'desc' : 'asc';

		await this.applyFilter();
	}
}
